$ = jQuery;
/*Functions*/

var aweberSubscribeForm = {

    cookieName: '_ga',
    cookieInputName: 'custom CID',
    urlInputName: 'custom Page URL',
    customRedirectInputName: 'aweber_subscribe_form_redirect',
    nameInputName: 'name',
    emailInputName: 'email',
    formWrapClass: 'aweber-subscribe-form-wrap',
    popupWrapClass: 'aweber-subscribe-popup-form-wrap',
    setCIDInterval: null,
    setCIDIntervalAttemptCuont: 0,
    setCIDIntervalMaxAttemptCuont: 100,

    getPageID: function () {
        if (
            global
            && global.queried_object
            && global.queried_object.ID
        ) {
            return global.queried_object.ID;
        }

        return 0;
    },
    getCookieItem: function () {

        var ga = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(aweberSubscribeForm.cookieName).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;

        if (!ga) {
            ga = 0;
        } else {
            ga = ga.replace('GA1.2.', '');
            ga = ga.replace('GA1.1.', '');
        }

        return ga;
    },
    setCID: function () {
        for (var i = 0; i < document.getElementsByName(aweberSubscribeForm.cookieInputName).length; i++) {
            document.getElementsByName(aweberSubscribeForm.cookieInputName)[i].value = aweberSubscribeForm.getCookieItem();
        }
        if (aweberSubscribeForm.getCookieItem().length) {
            clearInterval(aweberSubscribeForm.setCIDInterval);
        }
    },
    setCustomRedirect: function () {
        for (var i = 0; i < document.getElementsByName(aweberSubscribeForm.customRedirectInputName).length; i++) {
            document.getElementsByName(aweberSubscribeForm.customRedirectInputName)[i].value = window.location.href;
        }
    },
    setPageURL: function () {
        for (var i = 0; i < document.getElementsByName(aweberSubscribeForm.urlInputName).length; i++) {
            document.getElementsByName(aweberSubscribeForm.urlInputName)[i].value = window.location.href;
        }
    },
    sendDataToSimpleSubs: function () {

        $('.' + aweberSubscribeForm.formWrapClass + ' form').submit(function (e) {

            var $form = $(this);

            var data = {
                action: 'simple_subs_add_sub',
                email: $form.find("input[name=" + aweberSubscribeForm.emailInputName + "]").val(),
                name: $form.find("input[name=" + aweberSubscribeForm.nameInputName + "]").val(),
                id: aweberSubscribeForm.getPageID(),
                ga: aweberSubscribeForm.getCookieItem()
            };

            $.post(window.location.origin + '/wp-admin/admin-ajax.php', data, function (response) {
                try {
                    var res = JSON.parse(response);
                    console.log(response);
                    localStorage.setItem('cid', aweberSubscribeForm.getCookieItem());
                    localStorage.setItem('subscribe', 'yes');
                    $form.trigger('reset');
                    location.reload();
                } catch (e) {
                    console.log(e);
                }
            });
        });
    },
    togglePopup: function () {
        if ($('body').hasClass('aweber-subscribe-popup-form-open')) {
            aweberSubscribeForm.closePopup();
        } else {
            aweberSubscribeForm.openPopup();
        }
    },
    openPopup: function () {

        var $body = $('body');
        var data = {
            action: 'aweber_get_subscribe_popup_form_action',
        };

        $.post(window.location.origin + '/wp-admin/admin-ajax.php', data, function (response) {
            try {
                if (response.length) {
                    $body.append(response);
                    $body.find('.' + aweberSubscribeForm.popupWrapClass).fadeIn(300);
                    $body.addClass('aweber-subscribe-popup-form-open');

                    $body.find('.' + aweberSubscribeForm.popupWrapClass).find('.close').click(function () {
                        aweberSubscribeForm.closePopup();
                    });

                    aweberSubscribeForm.setCID();
                    aweberSubscribeForm.setPageURL();
                    aweberSubscribeForm.setCustomRedirect();
                    aweberSubscribeForm.sendDataToSimpleSubs();

                } else {
                    console.log('e');
                }
            } catch (e) {
                console.log(e);
            }
        });
    },

    closePopup: function () {
        var date = new Date();
        var hour = date.getHours();
        var expires = date.setHours(hour + 1);

        localStorage.setItem('cid', aweberSubscribeForm.getCookieItem());
        localStorage.setItem('expires', expires.toString());

        var $popupWrap = $('body').find('.' + this.popupWrapClass);
        $popupWrap.fadeOut(300);
        setTimeout(function () {
            $popupWrap.remove();
            $('body').removeClass('aweber-subscribe-popup-form-open');
        }, 500);
        location.reload();
    }
};

aweberSubscribeForm.setCIDInterval = setInterval(function () {
    aweberSubscribeForm.setCID();
    aweberSubscribeForm.setCIDIntervalAttemptCuont++;
    if (aweberSubscribeForm.setCIDIntervalAttemptCuont > aweberSubscribeForm.setCIDIntervalMaxAttemptCuont) {
        clearInterval(aweberSubscribeForm.setCIDInterval);
    }
}, 500);

aweberSubscribeForm.setPageURL();
aweberSubscribeForm.sendDataToSimpleSubs();
aweberSubscribeForm.setCustomRedirect();

var popup = {
    userCid: localStorage.getItem('cid'),
    userStatus: localStorage.getItem('subscribe'),
    userExpires: localStorage.getItem('expires'),

    open: function () {
        if (popup.userCid === aweberSubscribeForm.getCookieItem() && 'yes' === popup.userStatus) {
            return;
        }

        if (popup.userExpires > new Date()) {
            return;
        }

        setTimeout(function () {
            aweberSubscribeForm.openPopup();
        }, popup_conf.delay);
    }
}

$(document).ready(function () {
    if (popup_conf.enable == 1) {
        popup.open();
    }
})